export const statusHeaderTranslationEN = {
  Status_Header: {
    login_information: 'Login information',
    department_name: 'Department name',
    employee_name: 'Employee name',
    employee_code: 'Employee code',
    company_name: 'Company name',
    job_name: 'Job name',
    return: 'Return',
    logout: 'Logout',
    login_time: 'Login time',

    //menu
    group_store: 'Store Management',
    menu_store_setting: 'Store Setting',
    group_sale_type: 'Sale Type Management',
    menu_sale_type_list: 'Sale Type',
    group_menu_book: 'Menu Book Management',
    menu_menu_book_list: 'Menu Book',
    menu_genre_list: 'Genre',
    menu_subgenre_list: 'Sub Genre',
    menu_menu_list: 'Menu',
    menu_group_option_list: 'Group Option',
    group_delivery: 'Delivery Management',
    menu_delivery_setting: 'Delivery Setting',
    group_data: 'Data Capture',
    menu_import_register_data: 'Import register data',
  },
};
